import enGB from './i18n.en-GB.json.js';

//import daDK from "./i18n.da-DK.json"
//import deDE from "./i18n.de-DE.json"
// import enUS from "./i18n.en-US.json"
// import esES from "./i18n.es-ES.json"
// import esMX from "./i18n.es-MX.json"
// import esUS from "./i18n.es-US.json"
// import fiFI from "./i18n.fi-FI.json"
// import frFR from "./i18n.fr-FR.json"
// import itIT from "./i18n.it-IT.json"
// import nbNO from "./i18n.nb-NO.json"
// import nlNL from "./i18n.nl-NL.json"
// import ptBR from "./i18n.pt-BR.json"
// import svFI from "./i18n.sv-FI.json"
// import svSE from "./i18n.sv-SE.json"

const translations = {
  // "da-DK": daDK,
  // "de-DE": deDE,
  "en-GB": enGB
  // "en-US": enUS,
  // "es-ES": esES,
  // "es-US": esUS,
  // "es-MX": esMX,
  // "fi-FI": fiFI,
  // "fr-FR": frFR,
  // "it-IT": itIT,
  // "nb-NO": nbNO,
  // "nl-NL": nlNL,
  // "pt-BR": ptBR,
  // "sv-FI": svFI,
  // "sv-SE": svSE,
};

export { translations };
//# sourceMappingURL=index.js.map
